import { CommonTileLayer, InstanceAPI } from '@/api/internal';
import { LayerFormat, LayerType } from '@/geo/api';
import type { RampLayerConfig } from '@/geo/api';
import type { EsriImageryTileLayer, EsriImageryTileLayerProperties } from '@/geo/esri';
import { EsriAPI } from '@/geo/esri';
import { markRaw } from 'vue';

/**
 * A layer class which implements an ESRI ImageryTile Layer.
 */
export class ImageryTileLayer extends CommonTileLayer {
    declare esriLayer: EsriImageryTileLayer | undefined;

    constructor(rampConfig: RampLayerConfig, $iApi: InstanceAPI) {
        super(rampConfig, $iApi);

        this.layerType = LayerType.IMAGERYTILE;
        this.layerFormat = LayerFormat.IMAGERYTILE;
        this.schemaLocked = false;
    }

    protected async onInitiate(): Promise<void> {
        this.esriLayer = markRaw(await EsriAPI.ImageryTileLayer(this.makeEsriLayerConfig(this.origRampConfig)));
        await super.onInitiate();
    }

    /**
     * Take a layer config from the RAMP application and derives a configuration for an ESRI layer
     *
     * @param rampLayerConfig snippet from RAMP for this layer
     * @returns configuration object for the ESRI layer representing this layer
     */
    protected makeEsriLayerConfig(rampLayerConfig: RampLayerConfig): EsriImageryTileLayerProperties {
        const esriConfig: EsriImageryTileLayerProperties = super.makeEsriLayerConfig(rampLayerConfig);

        return esriConfig;
    }
}
